/**
 * Mark which bundle groups are still complete in cart.
 * Line items always show original catalog price; bundle discount is in cart/order summary only.
 */
export async function resolveBundlePricingForCartItems(items = [], getExpectedCount) {
  if (!items.length) return [];

  const bundleProductIds = [
    ...new Set(
      items
        .filter((item) => item?.bundleProductId)
        .map((item) => Number(item.bundleProductId))
        .filter((id) => id > 0)
    ),
  ];

  const expectedByBundle = new Map();
  await Promise.all(
    bundleProductIds.map(async (bundleProductId) => {
      const count = await getExpectedCount(bundleProductId);
      expectedByBundle.set(bundleProductId, count);
    })
  );

  const groups = new Map();
  items.forEach((item) => {
    if (!item?.bundleGroupId) return;
    const key = String(item.bundleGroupId);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(item);
  });

  return items.map((item) => {
    const originalPrice = Number(item.originalPrice ?? item.price ?? 0);
    const linePrice = item.isBundleItem ? originalPrice : Number(item.price ?? originalPrice);

    if (!item.isBundleItem || !item.bundleGroupId) {
      return {
        ...item,
        originalPrice,
        price: linePrice,
        bundleGroupComplete: false,
      };
    }

    const groupItems = groups.get(String(item.bundleGroupId)) ?? [];
    const bundleProductId = Number(item.bundleProductId ?? 0);
    const expected = expectedByBundle.get(bundleProductId) ?? groupItems.length;
    const bundleGroupComplete = groupItems.length >= expected && expected > 0;

    return {
      ...item,
      originalPrice,
      price: originalPrice,
      bundleGroupComplete,
    };
  });
}
